exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2IP9WzLQOYCEYO1QEFZ6us._1Ne_mw_RDjDhmTGzwWrTkQ{text-transform:initial !important}._2IP9WzLQOYCEYO1QEFZ6us.XjGLrAm6JtaXyuCICszdp{text-transform:uppercase !important}\n", ""]);

// exports
exports.locals = {
	"typography": "_2IP9WzLQOYCEYO1QEFZ6us",
	"initialCase": "_1Ne_mw_RDjDhmTGzwWrTkQ",
	"forceUppercase": "XjGLrAm6JtaXyuCICszdp"
};